import {ReactNode} from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import {SxProps, Theme} from '@mui/material/styles';
import {fonts, kit} from './tokens';

type SectionHeaderSize = 'sm' | 'md';

interface SectionHeaderProps {
  title: string;
  // Optional right-aligned action node (text-button / link / chip).
  action?: ReactNode;
  // 'md' (h5-ish 22px, default) or 'sm' (18px).
  size?: SectionHeaderSize;
  sx?: SxProps<Theme>;
}

const FONT_SIZE: Record<SectionHeaderSize, number> = {sm: 18, md: 22};

// Serif (TiemposTextRegular) section heading row with an optional right-side
// action -- the standard header above every redesigned list / card group.
const SectionHeader = ({
  title,
  action,
  size = 'md',
  sx,
}: SectionHeaderProps) => (
  <Box
    sx={[
      {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '12px',
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}>
    <Typography
      variant="h5"
      sx={{
        fontFamily: fonts.serif,
        fontSize: FONT_SIZE[size],
        lineHeight: 1.25,
        color: kit.ink,
      }}>
      {title}
    </Typography>
    {action ? <Box sx={{flexShrink: 0}}>{action}</Box> : null}
  </Box>
);

export default SectionHeader;
